import { SystemUserApiClass } from 'api/v2/SystemUserApi';
import Api from 'api/v2/Api';
import _ from 'lodash';
import axios from 'axios';

class WorkdayImportedUserApi extends SystemUserApiClass {
  constructor() {
    super('/api/search/systemusers', {
      filter: [
        { activated: { $eq: false } },
        {
          'attributes.name': 'WorkdayID',
        },
      ],
      skip: 0,
      limit: 20,
      sort: 'lastname',
    });
  }

  /**
   * Override method from base class because we are required to use the systemusers
   * v1 endpoint to fetch the users with a POST, not a GET.
   */
  fetch(skip, limit, sort) {
    const params = _.extend({}, this.defaultParams);

    params.skip = skip;
    params.limit = limit;
    params.sort = sort;

    return new Promise((resolve, reject) => {
      const mesg = 'Could not get Workday Imported users!';

      this.initialize()
        .then(() => {
          axios
            .post(
              `${this.baseUrl}`,
              {
                filter: params.filter,
                limit: params.limit,
                skip: params.skip,
                sort: params.sort,
              },
            )
            .then((resp) => {
              if (resp && resp.data && resp.data.results) {
                resolve({
                  results: resp.data.results,
                  totalCount: resp.data.totalCount,
                });
              } else {
                Api.handleError(reject, mesg);
              }
            })
            .catch((error) => {
              Api.handleError(reject, mesg, error);
            });
        })
        .catch((error) => {
          Api.handleError(reject, mesg, error);
        });
    });
  }

  /**
   * Override method from base class to use the custom fetch for this list
   */
  fetchAll() {
    const params = _.extend({}, this.defaultParams);

    params.skip = 0;
    params.limit = 100;

    return new Promise((resolve, reject) => {
      let users = [];
      const mesg = 'Unable to fetch all Workday Imported users!';

      const queryAllUsers = () => {
        this
          .fetch(params.skip, params.limit, params.sort)
          .then((data) => {
            users = users.concat(data.results);

            if (data.totalCount > params.skip + params.limit) {
              params.skip += params.limit;
              queryAllUsers();
            } else {
              resolve(users);
            }
          })
          .catch((error) => {
            Api.handleError(reject, mesg, error);
          });
      };

      queryAllUsers();
    });
  }
}

export default new WorkdayImportedUserApi();
